export class Validator{
	init(){
		if(typeof contactFormRules == 'object'){
			$('#contactForm').validate({
		        rules: contactFormRules,
		        errorPlacement: function(error, element) { },
		        submitHandler: function(text){
		            $.ajax({
		                url: $('#contactForm').attr("action"),
		                method: 'POST',
		                data: $('#contactForm').serialize(),
				        beforeSend: function() {
				        	$('#contactForm').find('button').prop('disabled', 'disabled');
				        },
		                success: function() {
		                    $('#contactForm').find('input, textarea').val('');
		                    $('#contactForm').fadeOut(500, function() {
		                        $('#contactForm').replaceWith('<div class="form__message form__message--success">Wiadomość została wysłana. Dziękujemy.</div>').fadeIn(500);
		                    });
		                },
		                error: function() {
		                    $('#contactForm').find('input, textarea').val('');
		                    $('#contactForm').fadeOut(500, function() {
		                        $('#contactForm').replaceWith('<div class="form__message form__message--error">Wiadomość nie została wysłana. Prosimy spróbować później.</div>').fadeIn(500);
		                    });
		                }
		            });
		        }
		    });
		}
	}
}